import React, { useState, useEffect } from "react";
import {
  FaFilter,
  FaCog,
  FaCalendarAlt,
  FaThLarge,
  FaPlus,
  FaEllipsisV,
  FaShare,
} from "react-icons/fa";
import axios from "axios";
import { baseurl } from "../Baseurl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";
import { ArrowLeft, Calendar, ChevronLeft, Share } from "react-feather";
import { BiLeftArrow } from "react-icons/bi";
import ProjectDocs from "../components/ProjectDocs";
import Select from "react-select";
import UserListTask from "../components/UserListTask";
import ShareProject from "../components/ShareProject";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { useNavigate } from "react-router-dom";


const getPriorityBadgeClass = (priority) => {
  switch (priority?.toLowerCase()) {
    case 'high':
      return 'bg-high text-white';   // Red
    case 'medium':
      return 'bg-std text-white';  // Blue
    case 'low':
      return 'bg-low text-white';  // Green
    default:
      return 'bg-secondary text-white'; // Fallback gray
  }
};


export default function SharedAccessNew() {
  const { id, title } = useParams();

  const [kanbanData, setKanbanData] = useState({
    "Not Started Yet": [],
     "In Progress": [],
    Open: [],
   
    Completed: [],
  });



const columnLabels = {
  "Not Started Yet": "Not Started Yet",
  "Open": "In Progress",      // show "In Progress" for "Open"
  "In Progress": "In Review", // show "In Review" for "In Progress"
  "Completed": "Completed",
};

  const [newTask, setNewTask] = useState({
    title: "",
    description: "",
    assignee: [],
    status: "Not Started Yet",
    plannedDate: "",
    completionDate: "",
    actualDate: "",
    priority: "Medium",
  });


 const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);
//    useEffect(() => {
//      const adminId = localStorage.getItem("adminID");
//      if (!adminId) {
//        navigate("/"); 
//      }
 
//      // 👇 load dark mode preference
//      const savedTheme = localStorage.getItem("darkMode") === "true";
//      setDarkMode(savedTheme);
//      document.body.classList.toggle("dark", savedTheme);
//    }, [navigate]);

   const [assignees, setAssignees] = useState([]);
  // const [newTask, setNewTask] = useState({
  //   assignee: []  
  // });

  // const handleInputChange = (selectedOptions) => {
  //   setNewTask((prev) => ({
  //     ...prev,
  //     assignee: selectedOptions.map((opt) => opt.value)
  //   }));
  // };

  useEffect(() => {
    const orgId = localStorage.getItem("organization_id");
    if (!orgId) return;

    axios.get(`${baseurl}getAssigneesByOrgId/${orgId}`)
      .then((res) => {
        if (res.data.assignees) {
          const options = res.data.assignees.map((user) => ({
            value: user.id,
            label: user.full_name
          }));
          setAssignees(options);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch assignees:", err);
      });
  }, []);



  const [isEditMode, setIsEditMode] = useState(false);
  const [editTaskId, setEditTaskId] = useState(null);

  const fetchTasks = async () => {
    try {
      const response = await axios.get(
        `${baseurl}getProductTasksByProjectId/${id}`
      );
      const grouped = {
        "Not Started Yet": [],
        Open: [],
        "In Progress": [],
        Completed: [],
      };

      response.data.forEach((task) => {
        const status = task.status || "Not Started Yet";
        grouped[status] = [
          ...grouped[status],
          {
            id: task.id,
            title: task.title,
            description: task.description,
            assignee: task.assignee,
            date: task.planned_date?.split("T")[0] || "",
            plannedDate: task.planned_date,
            completionDate: task.completion_date,
            actualDate: task.actual_date,
            priority: task.priority,
            assignees: task.assignees,
          },
        ];
      });

      setKanbanData(grouped);
    } catch (error) {
      console.error("Error fetching tasks:", error);
      toast.error("Failed to load tasks");
    }
  };

  // Then your useEffect stays like this:
  useEffect(() => {
    fetchTasks();
  }, [id]);

  const handleEdit = (task, column) => {
    setNewTask({
      title: task.title,
      description: task.description,
      assignee: task.assignee,
      status: column,
      plannedDate: task.plannedDate?.split("T")[0] || "",
      completionDate: task.completionDate?.split("T")[0] || "",
      actualDate: task.actualDate?.split("T")[0] || "",
      priority: task.priority || "Medium",
    });
    setIsEditMode(true);
    setEditTaskId(task.id);

    const modalEl = document.getElementById("addTaskModal");
    const modalInstance =
      window.bootstrap?.Modal.getInstance(modalEl) ||
      new window.bootstrap.Modal(modalEl);
    modalInstance.show();
  };

const handleDelete = async (taskId) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "Do you really want to delete this task?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
  });

  if (result.isConfirmed) {
    try {
      await axios.delete(`${baseurl}deleteProductTask/${taskId}`);

      // ✅ SweetAlert2 toast success
      Swal.fire({
  toast: true,
  position: "top-end",
  icon: "success",
  title: "Task deleted successfully!",
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
  customClass: {
    popup: "swal2-toast-success", // custom class for the toast container
    title: "swal2-toast-title",   // custom class for the title
    icon: "swal2-toast-icon",     // custom class for the icon
  },
});

      const updatedData = { ...kanbanData };
      Object.keys(updatedData).forEach((status) => {
        updatedData[status] = updatedData[status].filter(
          (task) => task.id !== taskId
        );
      });
      setKanbanData(updatedData);
    } catch (error) {
      console.error("Error deleting task:", error);

      // ❌ SweetAlert2 toast error
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Failed to delete task",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
    }
  }
};


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewTask({ ...newTask, [name]: value });
  };

  const handleAssigneeChange = (selectedOptions) => {
  setNewTask((prev) => ({
    ...prev,
    assignee: selectedOptions.map((opt) => opt.value)
  }));
};



  const handleSaveTask = async () => {
    try {
      if (isEditMode) {
        const payload = {
          id: editTaskId,
          ...newTask,
         plannedDate: newTask.plannedDate instanceof Date ? newTask.plannedDate.toISOString().split("T")[0] : newTask.plannedDate,
completionDate: newTask.completionDate instanceof Date ? newTask.completionDate.toISOString().split("T")[0] : newTask.completionDate,
actualDate: newTask.actualDate instanceof Date ? newTask.actualDate.toISOString().split("T")[0] : newTask.actualDate,

          project_id: id,
          adminID : localStorage.getItem('adminID'),
        };

        console.log("Sending task update payload:", payload); // ✅ Add this line

        await axios.post(`${baseurl}updateProductTask`, payload);
        toast.success("Task updated successfully!");
setTimeout(() => {
  window.location.reload();
}, 1000); // 1000 ms = 1 second
        // Replace task in state
        const updatedData = { ...kanbanData };
        Object.keys(updatedData).forEach((status) => {
          updatedData[status] = updatedData[status].map((task) =>
            task.id === editTaskId ? { ...task, ...newTask } : task
          );
        });
        fetchTasks();
        setKanbanData(updatedData);
      } else {
        await axios.post(`${baseurl}insertProductTask`, {
          ...newTask,
         plannedDate: newTask.plannedDate instanceof Date ? newTask.plannedDate.toISOString().split("T")[0] : newTask.plannedDate,
completionDate: newTask.completionDate instanceof Date ? newTask.completionDate.toISOString().split("T")[0] : newTask.completionDate,
actualDate: newTask.actualDate instanceof Date ? newTask.actualDate.toISOString().split("T")[0] : newTask.actualDate,

          project_id: id,
          adminID : localStorage.getItem('adminID'),
        });
        toast.success("Task added successfully!");
setTimeout(() => {
  window.location.reload();
}, 1000); // 1000 ms = 1 second
        await fetchTasks();
        const updatedData = { ...kanbanData };
        updatedData[newTask.status] = [...updatedData[newTask.status], newTask];
        setKanbanData(updatedData);
      }
    } catch (error) {
      console.error("Error saving task:", error);
      toast.error(isEditMode ? "Failed to update task" : "Failed to add task");
    }

    // Reset
    setNewTask({
      title: "",
      description: "",
      assignee: "",
      status: "Not Started Yet",
      plannedDate: "",
      completionDate: "",
      actualDate: "",
      priority: "Medium",
    });
    setIsEditMode(false);
    setEditTaskId(null);

    const modalEl = document.getElementById("addTaskModal");
    const modalInstance =
      window.bootstrap?.Modal.getInstance(modalEl) ||
      new window.bootstrap.Modal(modalEl);
    modalInstance.hide();
  };


  const unslugify = (slug) =>
  slug
    .replace(/-/g, ' ')                  // Replace dashes with spaces
    .replace(/\b\w/g, (c) => c.toUpperCase()); // Capitalize each word



// task modal view 
const [selectedTask, setSelectedTask] = useState(null);
const [priorityFilter, setPriorityFilter] = useState("All");

const handleTitleClick = (task) => {

  console.log("task", task);
  setSelectedTask(task);
  const modalEl = document.getElementById('taskDetailModal');
  const modal = new window.bootstrap.Modal(modalEl); // Use window.bootstrap
  modal.show();
};








 

const handleDragEnd = async (result) => {
  if (!result.destination) return;

  const { source, destination } = result;
  if (source.droppableId === destination.droppableId && source.index === destination.index) return;

  const sourceCol = source.droppableId;
  const destCol = destination.droppableId;

  // Copy kanbanData
  const updatedData = { ...kanbanData };
  const [movedTask] = updatedData[sourceCol].splice(source.index, 1);
  movedTask.status = destCol; // Update status locally
  updatedData[destCol].splice(destination.index, 0, movedTask);

  setKanbanData(updatedData);

  try {
    // Update DB
    await axios.post(`${baseurl}updateTaskStatus`, {
      id: movedTask.id,
      status: destCol,
      project_id: id,
      adminID: '0',
    });

    // ✅ SweetAlert2 toast
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "success",
      title: "Task status updated!",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });
  } catch (error) {
    console.error("Error updating task status:", error);

    // ❌ Error toast
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "error",
      title: "Failed to update task status",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });
  }
};









const columnColors = {
  'Not Started Yet': '#f8d7da',   // light red
  'Open': '#d1ecf1',              // light blue
  'In Progress': '#fff3cd',       // light yellow
  'Completed': '#d4edda',         // light green
};
  return (
    <div className="bg-light min-vh-100">
      {/* Top Header */}
      <div className="tab1 text-white d-flex justify-content-between align-items-center p-3">
        <h4 className="mb-0 fw-bold text-white">
          
          {unslugify(title)}
        </h4>
        <div className="d-flex align-items-center gap-2">
          <ProjectDocs projectId={id} />

          <Link
            to={`/project-detail/${id}/${title}`}
            className="btn btn-light btn-sm d-flex align-items-center gap-1"
          >
            <FaThLarge /> Kanban
          </Link>

          {/* <Link
            to={`/project-detail-calander/${id}/${title}`}
            className="btn btn-light btn-sm d-flex align-items-center gap-1 me-5"
          >
            <FaCalendarAlt /> Calendar
          </Link> */}

    

          {/* <UserListTask id={id} /> */}
        </div>
      </div>

      {/* Add Task Button */}
      <div className="px-3 py-1 d-flex justify-content-between align-items-center mb-1">
        <button
          className="btn new-project-btn d-flex align-items-center gap-1 px-3 py-2 tab4 mainttl  "
          data-bs-toggle="modal"
          data-bs-target="#addTaskModal"
        >
          <FaPlus /> Add Task
        </button>

        <div className="d-flex justify-content-end align-items-center  px-3">
          <label className="me-2 fw-semibold">Filter by Priority:</label>
          <select
            className="form-select form-select-sm w-auto"
            value={priorityFilter}
            onChange={(e) => setPriorityFilter(e.target.value)}
          >
            <option value="All">All</option>
            <option value="High">High</option>
            <option value="Medium">Medium</option>
            <option value="Low">Low</option>
          </select>
        </div>
      </div>

      {/* Kanban Board */}

      <div className="container-fluid px-3">
        <DragDropContext onDragEnd={handleDragEnd}>
          <div className="row g-3">
            {Object.entries(kanbanData).map(([column, tasks], index) => (
              <div key={index} className="col-md-3 col-sm-6 col-12">
                <div
                  className="border rounded shadow-sm p-3 h-100 d-flex flex-column"
                  style={{ backgroundColor: columnColors[column] }}
                >
                  <h6 className="text-dark border-bottom pb-2">
                    {column === "Open"
                      ? "In Progress"
                      : column === "In Progress"
                      ? "In Review"
                      : column}
                    <span className="text-muted">({tasks.length})</span>
                  </h6>

                  <Droppable droppableId={column}>
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className="flex-grow-1"
                      >
                       {tasks
  .filter(
    (task) =>
      priorityFilter === "All" || task.priority === priorityFilter
  )
  .map((task, i) => (
    <Draggable
      key={task.id ?? `temp-${i}`} // fallback key
      draggableId={(task.id ?? `temp-${i}`).toString()} // fallback id if undefined
      index={i}
    >
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  className="card mb-3 border-0"
                                >
                                  <div className="card-body p-2 position-relative">
                                    {/* <span className={`badge ${getPriorityBadgeClass(task.priority)} px-2 py-1`}>
                                  {task.priority}
                                </span> */}

                                    <div>
                                      <span
                                        className={`
    ${
      task.priority === "High"
        ? "high"
        : task.priority === "Medium"
        ? "medium"
        : "low"
    } 
    ${darkMode ? "dark" : ""}
  `}
                                      >
                                        <span className="me-1">◉</span>
                                        {task.priority || "Low"}
                                      </span>
                                    </div>

                                    <div className="d-flex justify-content-between">
                                      <h6
                                        className="card-title fw-bold mb-1 text-primary"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleTitleClick(task)}
                                      >
                                        <strong className={` mainttl ${darkMode ? "dark" : ""}`}>
                                         {task.title}
                                        </strong>
                                      </h6>
                                      <div className="dropdown">
                                        <button
                                          className="btn btn-sm p-0 border-0 bg-transparent"
                                          type="button"
                                          data-bs-toggle="dropdown"
                                        >
                                          <FaEllipsisV />
                                        </button>
                                        <ul className="dropdown-menu dropdown-menu-end">
                                          <li>
                                            <button
                                              className="dropdown-item"
                                              onClick={() =>
                                                handleEdit(task, column)
                                              }
                                            >
                                              Edit
                                            </button>
                                          </li>
                                          {/* <li>
                                            <button
                                              className="dropdown-item text-danger"
                                              onClick={() =>
                                                handleDelete(task.id)
                                              }
                                            >
                                              Delete
                                            </button>
                                          </li> */}
                                        </ul>
                                      </div>
                                    </div>

                                  

<p className={` small mb-0 mainttl ${darkMode ? "dark" : ""}`}><i>"{task.description}"</i></p>

                                    <hr/> 

                                    <div className="d-flex justify-content-between align-items-baseline">
                                     
                                     <div>
                                      {task.plannedDate && (
  <div>
    <p
      className={`mainttl ${darkMode ? "dark" : ""} small mb-0`}
      style={{ fontSize: "13px" }}
    >
      <Calendar className="me-2" />
      {new Date(task.actualDate).toLocaleDateString("en-US", {
        day: "2-digit",
        month: "short",
        year: "2-digit",
      })}
    </p>
  </div>
)}
                                     </div>

                                      <div>
                                        <div className="d-flex gap-1 mt-2 ms-2">
                                          {task.assignees?.map(
                                            (name, index) => {
                                              const initials = name
                                                .split(" ")
                                                .map((w) => w[0])
                                                .join("")
                                                .toUpperCase()
                                                .substring(0, 2);
                                              const colors = [
                                                "#0d6efd",
                                                "#6610f2",
                                                "#6f42c1",
                                                "#d63384",
                                                "#dc3545",
                                                "#fd7e14",
                                                "#ffc107",
                                                "#20c997",
                                                "#198754",
                                                "#0dcaf0",
                                              ];
                                              const hash = [...name].reduce(
                                                (a, c) => a + c.charCodeAt(0),
                                                0
                                              );
                                              const bgColor =
                                                colors[hash % colors.length];

                                              return (
                                                <div
                                                  key={index}
                                                  className="rounded-circle text-white d-flex align-items-center justify-content-center"
                                                  style={{
                                                    width: "30px",
                                                    height: "30px",
                                                    fontSize: "0.75rem",
                                                    fontWeight: "600",
                                                    marginLeft: "-10px",
                                                    border: "1px solid #fff",
                                                    backgroundColor: bgColor,
                                                  }}
                                                  title={name}
                                                >
                                                  {initials}
                                                </div>
                                              );
                                            }
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </div>
              </div>
            ))}
          </div>
        </DragDropContext>
      </div>

      {/* modal view click  */}
      <div
        className="modal fade"
        id="taskDetailModal"
        tabIndex="-1"
        aria-labelledby="taskDetailModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="taskDetailModalLabel">
                Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {selectedTask ? (
                <div className="table-responsive">
                  <table className="custom-table">
                    <tbody>
                      <tr>
                        <th>Title</th>
                        <td>{selectedTask.title}</td>
                      </tr>
                      <tr>
                        <th>Description</th>
                        <td>{selectedTask.description}</td>
                      </tr>

                      <tr>
                        <th>Priority</th>
                        <td>{selectedTask.priority}</td>
                      </tr>
                      <tr>
                        <th>Planned Date</th>
                        <td>
                          {selectedTask.plannedDate
                            ? new Date(
                                selectedTask.plannedDate
                              ).toLocaleDateString("en-IN", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                            : "-"}
                        </td>
                      </tr>
                      <tr>
                        <th>Completion Date</th>
                        <td>
                          {selectedTask.completionDate
                            ? new Date(
                                selectedTask.completionDate
                              ).toLocaleDateString("en-IN", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                            : "-"}
                        </td>
                      </tr>
                      <tr>
                        <th>Actual Date</th>
                        <td>
                          {selectedTask.actualDate
                            ? new Date(
                                selectedTask.actualDate
                              ).toLocaleDateString("en-IN", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                            : "-"}
                        </td>
                      </tr>
                      <tr>
                        <th>Created At</th>
                        <td>
                          {selectedTask.date
                            ? new Date(selectedTask.date).toLocaleDateString(
                                "en-IN",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                }
                              )
                            : "-"}
                        </td>
                      </tr>

                      <tr>
                        <th>Assignees</th>
                        <td>
                          {selectedTask.assignees?.length > 0
                            ? selectedTask.assignees.join(", ")
                            : "-"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ) : (
                <p>Loading...</p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Add Task Modal */}
      {/* Add Task Modal */}
      <div
        className="modal fade"
        id="addTaskModal"
        tabIndex="-1"
        aria-labelledby="addTaskModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addTaskModalLabel">
                {isEditMode ? "Update Task" : "Add Task"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-2">
                <div className="col-md-12">
                  <label className="form-label">Title</label>
                  <input
                    type="text"
                    name="title"
                    value={newTask.title}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
                <div className="col-md-12">
                  <label className="form-label">Description</label>
                  <textarea
                    name="description"
                    value={newTask.description}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>

                <div className="col-md-12">
                  <label className="form-label">User / Assignee</label>
                  <Select
                    options={assignees} // should be in format [{ value: id, label: full_name }]
                    isMulti
                    value={assignees.filter((opt) =>
                      newTask.assignee?.includes(opt.value)
                    )} // ✅ pre-select matching options
                    onChange={handleAssigneeChange}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select assignees"
                  />
                </div>

                <div className="col-md-12">
                  <label className="form-label">Status</label>
                  <select
  name="status"
  value={newTask.status}
  onChange={handleInputChange}
  className="form-select"
>
  {Object.keys(kanbanData).map((status) => (
    <option key={status} value={status}>
      {columnLabels[status] || status}
    </option>
  ))}
</select>
                </div>
 
                  

                  {/* <div className="col-md-4">
                    <label className="form-label  w-100">Completion Date</label>
                    <DatePicker
                      selected={newTask.completionDate}
                      onChange={(date) =>
                        setNewTask({ ...newTask, completionDate: date })
                      }
                      className="form-control  w-100"
                      dateFormat="yyyy-MM-dd"
                      placeholderText="Select date"
                    />
                  </div> */}

                  {/* <div className="col-md-4">
                    <label className="form-label  w-100">
                      Actual Completion Date
                    </label>
                    <DatePicker
                      selected={newTask.actualDate}
                      onChange={(date) =>
                        setNewTask({ ...newTask, actualDate: date })
                      }
                      className="form-control  w-100"
                      dateFormat="yyyy-MM-dd"
                      placeholderText="Select date"
                    />
                  </div> */}
                 

                <div className="col-md-4">
                  <label className="form-label">Priority</label>
                  <select
                    name="priority"
                    value={newTask.priority}
                    onChange={handleInputChange}
                    className="form-select"
                  >
                    <option value="Low">Low</option>
                    <option value="Medium">Medium</option>
                    <option value="High">High</option>
                  </select>
                </div>
                <div className="col-md-4">
                    <label className="form-label  w-100">
                      Due Date
                    </label>

                    <DatePicker
                      selected={newTask.plannedDate}
                      onChange={(date) =>
                        setNewTask({ ...newTask, plannedDate: date })
                      }
                      className="form-control  w-100"
                      dateFormat="yyyy-MM-dd"
                      placeholderText="Select date"
                    />
                  </div>

              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSaveTask}
              >
                {isEditMode ? "Update Task" : "Save Task"}
              </button>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
}
